import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ConfirmAccountComponent } from './confirm-account/confirm-account.component';
import { SignUpComponent } from './sign-up/sign-up.component';


const routes: Routes = [
  {
    path: 'sign-in',
    component: LoginComponent,
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
  },
  {
    path: 'confirm/:token',
    component: ConfirmAccountComponent
  },
  {
    // ✅ NUEVA: Ruta para activación de cuenta (alias de confirm)
    path: 'activate/:token',
    component: ConfirmAccountComponent
  },
  {
    // ✅ TEMPORAL: Ruta sin token para pruebas
    path: 'confirm',
    component: ConfirmAccountComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
